<template>
  <BasicLayout v-slot:default="slotProps">
    <div class="cancelled">
      <div class="cancelled__content">
        <dl class="contract-number">
          <dt>Auftragsnummer: </dt>
          <dd>{{ slotProps.number }}</dd>
        </dl>
        <div class="status-info__wrap">
          <div class="status-info">
            <div>
              <h2>Bestellung storniert</h2>
              <p class="status-info__text">
                Leider wurde Ihre Bestellung storniert, da das ausgewählte Fahrzeug nicht mehr
                verfügbar ist. Ihr Finanzierungsantrag ist damit aufgehoben.
              </p>
            </div>
            <div class="cancelled__new-search-wrap">
              <img src="../assets/images/driver.png" alt="" />
              <div class="cancelled__new-search">
                <h4>Neues Fahrzeug finden</h4>
                <p>
                  Wir haben noch weitere interessante Fahrzeuge für Sie in unserer Fahrzeugbörse.
                </p>
                <a href="https://suche.pkw.de/fahrzeuge?available_online=true">Fahrzeuge ansehen</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Contacts />
    </div>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../components/layout/BasicLayout';
import Contacts from '../components/Contacts';
import Status from '../components/Status';

export default {
  components: {
    BasicLayout,
    Contacts,
    Status,
  },
};
</script>

<style lang="scss" scoped>
.cancelled {
  &__new-search-wrap {
    margin-top: 1.25rem;
    background-color: $green;
    img {
      width: 100%;
    }
  }
  &__new-search {
    padding: 0.9375rem 1.25rem;
    background-color: $green;
    color: $white;
    h4 {
      margin-bottom: 0.3125rem;
      font-size: 1rem;
      font-weight: 700;
    }
    p {
      font-size: 0.8125rem;
      line-height: 1.25rem;
    }
    a {
      display: block;
      padding: 0.75rem;
      margin-top: 1.25rem;
      font-size: 0.875rem;
      font-weight: 700;
      text-align: center;
      background-color: $white;
      color: $darkgray;
    }
  }
  @include breakpoint(tablet) {
    max-width: 44.375rem;
    margin: 0 auto;
    padding: 1.25rem 1.875rem;
    background-color: #e5e5e5;
    &__new-search-wrap {
      display: flex;
      img {
        width: 40%;
      }
    }
  }
  @include breakpoint(desktop) {
    padding: 30px;
    .contract-number {
      margin-bottom: 0;
    }
  }
}

.status-info {
  h2 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  &__wrap {
    padding: 1.25rem 0.625rem;
  }
  &__text {
    font-size: 16px;
    line-height: 22px;
  }
  &__status {
    padding: 1.25rem;
    margin-top: 1.25rem;
    border: 0.0625rem solid $border-gray;
    h4 {
      padding-bottom: 0.3125rem;
      font-size: 1rem;
      font-weight: 700;
    }
    p {
      font-size: 0.875rem;
      color: $green;
    }
  }
  @include breakpoint(desktop) {
    padding: 1.25rem 0;
    h2 {
      font-size: 18px;
      padding-bottom: 10px;
    }
    h3 {
      font-size: 26px;
    }
    h4 {
      font-size: 20px;
    }
    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
